import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Store, FileText, BookOpen, Layers, Sparkles, ChevronRight } from 'lucide-react';
import api from '../utils/api';

const SmartVyaparWidget = () => {
  const [stats, setStats] = useState({ users: null, active_subs: null, businesses: null });

  useEffect(() => {
    // Public stats (best-effort, silent fail — widget always renders)
    api.get('/vyapar/stats/public').then((r) => setStats(r.data || {})).catch(() => {});
  }, []);

  return (
    <section className="py-8 px-4" data-testid="smart-vyapar-widget">
      <div className="max-w-7xl mx-auto">
        <div className="bg-gradient-to-br from-fuchsia-500/10 via-indigo-500/10 to-emerald-500/10 border border-fuchsia-500/30 rounded-2xl p-6 lg:p-8 backdrop-blur-sm">
          <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
            <div>
              <div className="flex items-center gap-2">
                <span className="text-xs px-2 py-1 bg-fuchsia-500/20 text-fuchsia-200 rounded-full font-semibold">BUSINESS · ERP</span>
                <span className="text-xs px-2 py-1 bg-emerald-500/20 text-emerald-300 rounded-full font-semibold">NEW · AI POWERED</span>
              </div>
              <h2 className="text-2xl lg:text-3xl font-bold mt-2 bg-gradient-to-r from-fuchsia-300 via-pink-300 to-amber-300 bg-clip-text text-transparent">
                Anant Smart Vyapar System
              </h2>
              <p className="text-sm text-slate-300 mt-1">
                A complete business management service for any type of business &amp; service providers.
                CRM · Billing · Khata Bahi · Full ERP Accounting · AI-driven.
              </p>
            </div>
            <Link
              to="/vyapar"
              className="px-5 py-3 bg-gradient-to-r from-fuchsia-500 to-pink-500 text-white font-bold rounded-xl flex items-center gap-2 hover:scale-105 transition shadow-lg shadow-fuchsia-500/30"
              data-testid="smart-vyapar-cta"
            >
              <Sparkles className="w-4 h-4" />
              Open Smart Vyapar
              <ChevronRight className="w-4 h-4" />
            </Link>
          </div>

          {/* 4 feature cards (matching AVX StatCard layout) */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            <FeatureCard
              icon={<Layers className="w-4 h-4" />}
              label="Chart of Accounts"
              value="Tally-style"
              sub="19 seed accounts"
              color="from-emerald-500/20 to-teal-500/20 border-emerald-500/30"
            />
            <FeatureCard
              icon={<FileText className="w-4 h-4" />}
              label="Vouchers"
              value="8 Types"
              sub="Double-Entry"
              color="from-blue-500/20 to-cyan-500/20 border-blue-500/30"
            />
            <FeatureCard
              icon={<BookOpen className="w-4 h-4" />}
              label="Reports"
              value="Trial · P&L · BS"
              sub="1-click PDF"
              color="from-purple-500/20 to-pink-500/20 border-purple-500/30"
            />
            <FeatureCard
              icon={<Store className="w-4 h-4" />}
              label={stats.businesses ? 'Businesses' : 'Multi-Business'}
              value={stats.businesses ? String(stats.businesses) : 'Multi-Category'}
              sub={stats.active_subs ? `${stats.active_subs} active` : 'CRM · Stock · QR'}
              color="from-amber-500/20 to-orange-500/20 border-amber-500/30"
            />
          </div>

          {/* Feature strip */}
          <div className="mt-5 flex flex-wrap gap-2">
            {[
              '🧾 Sales / Purchase',
              '💰 Receipt / Payment',
              '📚 Journal / Contra',
              '↩️ Debit / Credit Note',
              '🧠 AI Account Suggest',
              '📄 PDF Cashbook',
              '📱 WhatsApp Udhari',
              '🏷️ Magic QR',
            ].map((t) => (
              <span key={t} className="text-xs bg-slate-800/60 border border-slate-700 rounded-full px-3 py-1 text-slate-200">
                {t}
              </span>
            ))}
          </div>

          <div className="mt-4 text-xs text-fuchsia-200/80">
            🚀 Free 7-day trial · Monthly / Yearly plans · Yearly gets FREE Done-For-You onboarding
          </div>
        </div>
      </div>
    </section>
  );
};

const FeatureCard = ({ icon, label, value, sub, color }) => (
  <div className={`bg-gradient-to-br ${color} border rounded-xl p-4`}>
    <div className="flex items-center gap-2 text-slate-300 text-xs">
      {icon}
      <span>{label}</span>
    </div>
    <div className="text-xl font-bold text-white mt-1">{value}</div>
    {sub && <div className="text-[10px] text-slate-400 mt-0.5">{sub}</div>}
  </div>
);

export default SmartVyaparWidget;
